import Table from '@/components/Table';
import agentMutations from '@/api/mutitations/agent';
import { notifications } from '@mantine/notifications';
import prepareTranslate from '@/helpers/dictionary';
import { Container } from '@mantine/core';
import {
  IconEye,
} from '@tabler/icons-react';
import PageTemplate from '@/components/PageTemplate';
import { useState } from 'react';
import { extractFilterOptions } from '@/components/Table/Table.functions';
import { useNavigate } from 'react-router-dom';
import { routeWithParams } from '@/helpers/route';
import routes from '@/routes';

const Agents = () => {
  const t = prepareTranslate();
  const [filterOptions, setFilterOptions] = useState({});
  const navigate = useNavigate();

  const { mutateAsync: agentMutate } = agentMutations.useGetArchivedAgents();

  // eslint-disable-next-line consistent-return
  const getData = async (start, end, query, sort) => {
    try {
      const getAgentsDataObj = {
        start,
        end,
        query,
        sort,
      };
      const agentsData = await agentMutate(getAgentsDataObj);
      const newFilterOptions = extractFilterOptions(agentsData.data, mockColumns);
      setFilterOptions(newFilterOptions);

      return agentsData;
    } catch (error) {
      notifications.show({
        title: t('pages.agentsArchived.notification.errors.find.title'),
        message: t('pages.agentsArchived.notification.errors.find.message'),
      });
      // eslint-disable-next-line no-console
      console.error('Error fetching users:', error);
    }
  };

  const handleClickOnView = (id) => {
    navigate(routeWithParams(routes.agentView.path, {
      id, tab: 'details', state: 'view', status: 'archive',
    }));
  };

  const mockColumns = [
    {
      title: 'תעודת זהות',
      accessor: 'personalDetails.uid',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'שם פרטי',
      accessor: 'personalDetails.firstName',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'שם משפחה',
      accessor: 'personalDetails.lastName',
      isVisible: true,
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'טלפון',
      accessor: 'personalDetails.phone',
      isVisible: true,
      transforms: ['phone'],
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'דואר אלקטרוני',
      accessor: 'personalDetails.email',
      isVisible: true,
      transforms: ['email'],
      isFilterActive: true,
      sortable: true,
    },
    {
      title: 'פעולות',
      actions: [
        {
          title: 'צפייה',
          action: handleClickOnView,
          icon: <IconEye />,
          showLabel: true,
          isPrimary: true,
        },
      ],
    },
  ];

  const initialColumnFilters = mockColumns
    .filter((column) => column.accessor !== 'actions')
    .reduce((acc, column) => {
      acc[column.accessor] = '';
      return acc;
    }, {});

  const [columnFilters, setColumnFilters] = useState(initialColumnFilters);

  return (
    <>
      <PageTemplate
        title={t('pages.agentsArchived.title')}
        withBackButton={true}
      >

        <Container fluid>
          <Table
            isExportActive={false}
            columns={mockColumns}
            getData={getData}
            isColumnsActive={false}
            columnFilters={columnFilters}
            setColumnFilters={setColumnFilters}
            filterOptions={filterOptions}
          />
        </Container>
      </PageTemplate>
    </>
  );
};

export default Agents;
